import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionarproducte from "./Seleccionarproducte";
import Detallsproducte from "./Detallsproducte";
import AtributsProducte from "./Atributsproducte";
import ProveidorsProducte from "./Proveidorsproducte";
import PackProducte from "./Packproducte";
import "../dashboard_v2.css";
import AjudaCataleg from "./AjudaCataleg";
import { BotoAjuda } from "./AjudaModal";

function idProducte(p) {
  return p ? Number(p.idProductes) : null;
}

function esPack(p) {
  return Number(p?.EsPack) === 1;
}

function PestanyesProducte({ active, onChange, producte }) {
  return (
    <nav className="dv2-subnav" aria-label="Seccions del producte">
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "dades" ? "is-active" : ""}`}
        onClick={() => onChange("dades")}
      >
        Dades
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "proveidors" ? "is-active" : ""}`}
        onClick={() => onChange("proveidors")}
      >
        Preus proveïdors
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "atributs" ? "is-active" : ""}`}
        onClick={() => onChange("atributs")}
      >
        Atributs
      </button>
      {esPack(producte) && (
        <button
          type="button"
          className={`dv2-subnav-btn ${active === "pack" ? "is-active" : ""}`}
          onClick={() => onChange("pack")}
        >
          Pack
        </button>
      )}
    </nav>
  );
}

function Productes() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [categoriaFilter, setCategoriaFilter] = useState("");
  const [tipusFilter, setTipusFilter] = useState("");
  const [materialFilter, setMaterialFilter] = useState("");
  const [reloadToken, setReloadToken] = useState(0);
  const [productes, setProductes] = useState([]);
  const { rolUsuari } = useUserContext();
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleProductSelect = (product) => {
    if (!product) {
      setSelectedProduct(null);
      return;
    }
    setSelectedProduct((prev) => (idProducte(prev) === idProducte(product) ? null : product));
  };

  const obrirFitxa = (product, mode) => {
    setSelectedProduct(product);
    setActiveTab(mode);
  };

  const canviarSeccio = (seccio) => {
    if (seccio === "dades") {
      setActiveTab("consultar");
      return;
    }
    setActiveTab(seccio);
  };

  const seccioActiva =
    activeTab === "proveidors" || activeTab === "atributs" || activeTab === "pack"
      ? activeTab
      : "dades";

  const esLlista = activeTab === "seleccionar";
  const mostraPestanyes = selectedProduct && !["nou", "esborrar"].includes(activeTab);
  const subnav = mostraPestanyes ? (
    <PestanyesProducte active={seccioActiva} onChange={canviarSeccio} producte={selectedProduct} />
  ) : null;

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaCataleg pestanya="productes" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                📦
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Productes</h1>
                <p className="dv2-pageHeader-subtitle">
                  Catàleg per marca i model, amb preus, atributs tècnics i packs.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Productes" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedProduct(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou producte
                </button>
              )}
            </div>
          </div>

          <Seleccionarproducte
            onProductSelect={handleProductSelect}
            onConsultar={(p) => obrirFitxa(p, "consultar")}
            onModificar={(p) => obrirFitxa(p, "modificar")}
            onEsborrar={(p) => obrirFitxa(p, "esborrar")}
            onPreus={(p) => obrirFitxa(p, "proveidors")}
            onAtributs={(p) => obrirFitxa(p, "atributs")}
            onPack={(p) => obrirFitxa(p, "pack")}
            selectedProduct={selectedProduct}
            setProductes={setProductes}
            filterText={filterText}
            setFilterText={setFilterText}
            categoriaFilter={categoriaFilter}
            setCategoriaFilter={setCategoriaFilter}
            tipusFilter={tipusFilter}
            setTipusFilter={setTipusFilter}
            materialFilter={materialFilter}
            setMaterialFilter={setMaterialFilter}
            reloadToken={reloadToken}
          />
        </>
      ) : activeTab === "proveidors" ? (
        <ProveidorsProducte
          product={selectedProduct}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
        />
      ) : activeTab === "atributs" ? (
        <AtributsProducte
          producte={selectedProduct}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
        />
      ) : activeTab === "pack" ? (
        <PackProducte
          producte={selectedProduct}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
          onActivat={() => {
            setSelectedProduct((actual) => (actual ? { ...actual, PackComposicioActiva: 1 } : actual));
            setReloadToken((n) => n + 1);
          }}
        />
      ) : (
        <Detallsproducte
          mode={activeTab}
          product={activeTab === "nou" ? null : selectedProduct}
          productes={productes}
          subnav={subnav}
          onNavigate={setSelectedProduct}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedProduct(updated);
            setProductes((prev) =>
              (prev || []).map((p) => (idProducte(p) === idProducte(updated) ? { ...p, ...updated } : p))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Productes;
